export default {
  'accountandsettings.menuMap.basic': 'Basic Settings',
  'accountandsettings.menuMap.security': 'Security Settings',
  'accountandsettings.menuMap.binding': 'Account Binding',
  'accountandsettings.menuMap.notification': 'New Message Notification',
  'accountandsettings.basic.avatar': 'Avatar',
  'accountandsettings.basic.change-avatar': 'Change avatar',
  'accountandsettings.basic.email': 'Email',
  'accountandsettings.basic.email-message': 'Please input your email!',
  'accountandsettings.basic.nickname': 'Nickname',
  'accountandsettings.basic.nickname-message': 'Please input your Nickname!',
  'accountandsettings.basic.profile': 'Personal profile',
  'accountandsettings.basic.profile-message': 'Please input your personal profile!',
  'accountandsettings.basic.profile-placeholder': 'Brief introduction to yourself',
  'accountandsettings.basic.country': 'Country/Region',
  'accountandsettings.basic.country-message': 'Please input your country!',
  'accountandsettings.basic.geographic': 'Province or city',
  'accountandsettings.basic.geographic-message': 'Please input your geographic info!',
  'accountandsettings.basic.address': 'Street Address',
  'accountandsettings.basic.address-message': 'Please input your address!',
  'accountandsettings.basic.phone': 'Phone Number',
  'accountandsettings.basic.phone-message': 'Please input your phone!',
  'accountandsettings.basic.update': 'Update Information',
  'accountandsettings.basic.update.success': 'Update basic information successfully',
  'accountandsettings.security.strong': 'Strong',
  'accountandsettings.security.medium': 'Medium',
  'accountandsettings.security.weak': 'Weak',
  'accountandsettings.security.password': 'Account Password',
  'accountandsettings.security.password-description': 'Current password strength：',
  'accountandsettings.security.phone': 'Security Phone',
  'accountandsettings.security.phone-description': 'Bound phone：',
  'accountandsettings.security.question': 'Security Question',
  'accountandsettings.security.question-description':
    'The security question is not set, and the security policy can effectively protect the account security',
  'accountandsettings.security.email': 'Backup Email',
  'accountandsettings.security.email-description': 'Bound Email：',
  'accountandsettings.security.mfa': 'MFA Device',
  'accountandsettings.security.mfa-description':
    'Unbound MFA device, after binding, can be confirmed twice',
  'accountandsettings.security.modify': 'Modify',
  'accountandsettings.security.set': 'Set',
  'accountandsettings.security.bind': 'Bind',
  'accountandsettings.binding.taobao': 'Binding Taobao',
  'accountandsettings.binding.taobao-description': 'Currently unbound Taobao account',
  'accountandsettings.binding.alipay': 'Binding Alipay',
  'accountandsettings.binding.alipay-description': 'Currently unbound Alipay account',
  'accountandsettings.binding.dingding': 'Binding DingTalk',
  'accountandsettings.binding.dingding-description': 'Currently unbound DingTalk account',
  'accountandsettings.binding.bind': 'Bind',
  'accountandsettings.notification.password': 'Account Password',
  'accountandsettings.notification.password-description':
    'Messages from other users will be notified in the form of a station letter',
  'accountandsettings.notification.messages': 'System Messages',
  'accountandsettings.notification.messages-description':
    'System messages will be notified in the form of a station letter',
  'accountandsettings.notification.todo': 'To-do Notification',
  'accountandsettings.notification.todo-description':
    'The to-do list will be notified in the form of a letter from the station',
  'accountandsettings.settings.open': 'Open',
  'accountandsettings.settings.close': 'Close',
};
